const now = new Date();
const currentYear = 2025;

const adventDates = [
  new Date(currentYear, 10, 30), // November 30 (month is 0-indexed)
  new Date(currentYear, 11, 7), // December 7
  new Date(currentYear, 11, 14), // December 14
  new Date(currentYear, 11, 21), // December 21
  new Date(currentYear, 11, 28), // December 28
];

let week = 0;
for (let i = 0; i < adventDates.length; i++) {
  const adventDate = adventDates[i];
  if (adventDate && now >= adventDate) {
    week = i + 1;
  }
}

export function AdventCandlestick() {
  if (week < 0 || week > 4) {
    return null;
  }

  return (
    <div className="h-24 w-auto">
      <AdventSVG adventWeek={week} />
    </div>
  );
}

type AdventSVGProps = {
  adventWeek: number;
};

function AdventSVG({ adventWeek }: AdventSVGProps) {
  const baseHeight = 100;
  const baseY = 100;
  const segmentHeight = 25;

  const getCandleProps = (candleIndex: number) => {
    const isLit = candleIndex < adventWeek;

    if (!isLit) {
      return {
        height: baseHeight,
        y: baseY,
        showFlame: false,
        showWick: true,
        flameY: baseY,
      };
    }

    const effectiveWeeksBurned = adventWeek - (candleIndex + 1);
    const newHeight = baseHeight - effectiveWeeksBurned * segmentHeight;
    const newY = baseY + effectiveWeeksBurned * segmentHeight;

    return {
      height: newHeight,
      y: newY,
      showFlame: true,
      showWick: false,
      flameY: newY,
    };
  };

  const candles = [
    { id: 1, x: 100, wickX: 110, flameX: 110 },
    { id: 2, x: 160, wickX: 170, flameX: 170 },
    { id: 3, x: 220, wickX: 230, flameX: 230 },
    { id: 4, x: 280, wickX: 290, flameX: 290 },
  ];

  return (
    <svg
      className="h-full w-auto"
      viewBox="0 0 400 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="80"
        y="200"
        width="240"
        height="20"
        fill="#B91C1C"
        stroke="#921616"
        strokeWidth="2"
        rx="5"
        ry="5"
      />

      {candles.map((candle, index) => {
        const props = getCandleProps(index);

        return (
          <g key={candle.id}>
            <rect
              x={candle.x}
              y={props.y}
              width="20"
              height={props.height}
              fill="#F7FAFC"
              stroke="#CBD5E0"
              strokeWidth="1"
              rx="5"
              ry="5"
            />

            {props.showWick && (
              <line
                x1={candle.wickX}
                y1={baseY}
                x2={candle.wickX}
                y2={baseY - 10}
                stroke="#333"
                strokeWidth="2"
              />
            )}

            {props.showFlame && (
              <g transform={`translate(${candle.flameX}, ${props.flameY})`}>
                <path fill="orange" opacity="0.9">
                  <animate
                    attributeName="d"
                    values="M 0 0 Q 8 -12 0 -24 Q -8 -12 0 0 Z; M 0 0 Q 10 -14 0 -28 Q -10 -14 0 0 Z; M 0 0 Q 8 -12 0 -24 Q -8 -12 0 0 Z"
                    dur="0.5s"
                    repeatCount="indefinite"
                  />
                </path>
                <path fill="yellow" opacity="0.9">
                  <animate
                    attributeName="d"
                    values="M 0 -6 Q 4 -10 0 -16 Q -4 -10 0 -6 Z; M 0 -8 Q 5 -12 0 -18 Q -5 -12 0 -8 Z; M 0 -6 Q 4 -10 0 -16 Q -4 -10 0 -6 Z"
                    dur="0.5s"
                    repeatCount="indefinite"
                  />
                </path>
                <animateTransform
                  attributeName="transform"
                  type="skewX"
                  values="-1;1;-1"
                  dur="1.5s"
                  repeatCount="indefinite"
                  additive="sum"
                />
              </g>
            )}
          </g>
        );
      })}
    </svg>
  );
}
